export default "__VITE_PUBLIC_ASSET__fd107bbf__"